// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"CredentialsModal_modalFooter__gJxe-","content":"CredentialsModal_content__1SaEs"};